import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { colord } from 'colord';
import { MenuItem } from 'primeng/api';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardCardComponent {
    private app = inject(MainAppService);

    @Input() title = '';
    @Input() additionalText = '';
    @Input() icon = '';
    @Input() icon2 = '';
    @Input() iconIsFile = false;
    @Input() border = "";

    @Input() menuItems: MenuItem[] | undefined;
    @Input() menuButton = false;

    @Input() routerLink: string[] | undefined;
    @Output() click2 = new EventEmitter<void>();

    _backgroundColor = '#ffffff';
    iconColor = '#58799f';
    iconBackgroundColor = '#d1e8fa';
    fontColor = '#000000';
    private _iconColorAuto = false;

    @Input() set backgroundColor(value: string) {
        this._backgroundColor = value;
        this.fontColor = Utils.getTextColor(value);
        this.updateIconColors();
    }

    @Input() set iconColorAuto(v: boolean) {
        this._iconColorAuto = v;
        this.updateIconColors();
    }

    async onCardClick(_: Event): Promise<void> {
        this.click2.emit();
        if (this.routerLink) {
            await this.app.navigateTo(this.routerLink);
        }
    }

    private updateIconColors(): void {
        if (this._iconColorAuto) {
            this.iconColor = this._backgroundColor;
            this.iconBackgroundColor = colord(this.iconColor).lighten(0.3).toHex();
        }
    }
}
